import Keycloak from "keycloak-js";

const keycloak = Keycloak("keycloak.json");

export { keycloak };
